import { COMPANY_INITIALS, COMPANY_SHORT } from '../constants';

const navItems = [
  { label: 'Profile', href: '#about' },
  { label: 'Filing', href: '#care' },
  { label: 'Address', href: '#visit' },
];

function Header() {
  return (
    <header className="sticky top-0 z-30 border-b border-line/80 bg-paper/90 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-4">
        <a
          href="#top"
          className="flex min-w-0 items-center gap-3"
          aria-label={`${COMPANY_SHORT} home`}
        >
          <span className="grid h-11 w-11 shrink-0 place-items-center rounded-lg bg-midnight text-sm font-black text-signal shadow-ring">
            {COMPANY_INITIALS}
          </span>
          <span className="truncate text-lg font-black uppercase tracking-[0.12em] text-midnight sm:text-xl">
            {COMPANY_SHORT}
          </span>
        </a>
        <nav
          className="hidden items-center gap-2 md:flex"
          aria-label="Primary"
        >
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-pill px-4 py-2 text-sm font-semibold text-muted transition hover:bg-frost hover:text-ocean"
            >
              {item.label}
            </a>
          ))}
        </nav>
        <a
          href="#visit"
          className="rounded-pill bg-signal px-5 py-2.5 text-sm font-black text-midnight transition hover:bg-mint"
        >
          Open maps
        </a>
      </div>
    </header>
  );
}

export default Header;
